import ReminderBox from "./ReminderBox/ReminderBox";
import styles from "./ReminderList.module.css";

const ReminderList = ({ tasks = [], eventId, eventTitle }) => {
  return (
    <div className={styles.container}>
      <div className="reminderListHeader">Send Group Reminder</div>
      <div className={styles.content}>
        {tasks.map((task, index) => {
          return <ReminderBox key={"Task" + index} task={task} eventId={eventId} eventTitle={eventTitle} />;
        })}
      </div>
    </div>
  );
};

export default ReminderList;
